module.exports = __webpack_public_path__ + "static/FitnessRoom-1760ea05e9b129c8dc3c464d19e8e6b0.jpg";